import { render, staticRenderFns } from "./PaymentUpdateLinkPopup.vue?vue&type=template&id=5229c7bb&scoped=true&"
import script from "./PaymentUpdateLinkPopup.vue?vue&type=script&lang=js&"
export * from "./PaymentUpdateLinkPopup.vue?vue&type=script&lang=js&"
import style0 from "./PaymentUpdateLinkPopup.vue?vue&type=style&index=0&id=5229c7bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5229c7bb",
  null
  
)

export default component.exports